import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from '@shared/services/settings.service';

@Component({
  selector: 'app-translate',
  template: `

<div style="flex flex-row;display: flex; align-items: center; justify-content: center;">
    <button mat-icon-button aria-label="select language" class="matero-toolbar-button" [matMenuTriggerFor]="menu">
    <mat-icon>language</mat-icon>
    </button>

    <span style="font-size: small;">{{ 'accessibility.languages' | translate }}</span>
  
    </div>

    <mat-menu #menu="matMenu">
      <button mat-menu-item *ngFor="let lang of langs | keyvalue" aria-label="language selection" 
        (click)="useLanguage(lang.key)">
        <span>{{ lang.value }}</span>
      </button>
    </mat-menu>
  `,
  styles: [],
})
export class TranslateComponent {

  langs = {
    'en-US': 'English',
    'es-SPA': 'Spanish / Español',
    'ko-KR': 'Korean / 한국어',
    'ru-RU': 'Russian / Русский',
    'vi-VN': 'Vietnamese / Tiếng Việt',
    'zh-CN': 'Chinese / 简体中文',
  };

  constructor(private translate: TranslateService, private settings: SettingsService) {
    translate.addLangs(['en-US', 'es_SPA', 'ko-KR', 'ru-RU', 'vi-VN', 'zh-CN']);
  }

  useLanguage(language: string) {
    this.translate.use(language);
    this.settings.setLanguage(language);
  }
}
